/* eslint-disable consistent-return */
import { Form, MapContainer, DuoGrid, TitleFloat, TextFloat, MapFloat, LineSpacer, SearchContainer } from './styles';
import React, { useState, useRef, useMemo } from 'react';
import { Marker, Popup, GeoJSON } from 'react-leaflet';
import { RouteComponentProps } from 'react-router-dom';
import { FrameData } from '../../components/FrameData';
import { AutoRow } from 'components/AutoRow';
import Input from 'components/AutoRow/components/Input';
import { Button } from 'components/AutoRow/components/Button';
import { FaSearch } from 'react-icons/fa';
import { IMapContainer, Map as Mapa } from 'components/Map';
import { useIframeContext } from 'contexts/IframeContext';
import dayjs from 'dayjs';
import { timeToMilliseconds } from 'utils/time';
import L from 'leaflet';
import Home from '../../assets/Home.png'; // PRECISA SER PNG, NADA DE SVG!!!
import { makeHandleSubmit } from 'helpers/makeHandleSubmit';
import { EmptyData } from 'components/EmptyData';
import { FaRegCompass } from 'react-icons/fa6';
import { MdMyLocation } from 'react-icons/md';

const MarkerIcon = new L.Icon({
  iconUrl: Home,
  iconRetinaUrl: Home,
  iconSize: new L.Point(60, 60),
  iconAnchor: [30, 45],
});

const IframeColeta = ({ history }: RouteComponentProps) => {
  const [mapLatLng, setMapLatLng] = useState<[number, number]>([-1.440077, -48.471985]);
  const mapElement = useRef<IMapContainer>();

  const {
    coordsParque,
    dadosConsultaAreaColeta,
    handleBuscarAreaColeta,
    setDadosConsultaAreaColeta,
    erroConsultaAreaColeta,
  } = useIframeContext();

  const {
    areaColetaBuscada,
    dataConsulta,
    loading,
    loading_buscar_com_localizacao,
    enderecoBuscado,
  } = dadosConsultaAreaColeta;

  const infoColeta = useMemo(() => {
    if (!areaColetaBuscada) return [];

    const dias = ['Dom', 'Seg', 'Ter', 'Quar', 'Qui', 'Sex', 'Sáb'];

    const infoHorarios = new Map();
    const menorHorarioDias = new Map<number, { hora: number; horario: string; horarioTime: number; turno: string }>();

    areaColetaBuscada.area_coleta_horario?.forEach((horarioColeta) => {
      const horarioTime = timeToMilliseconds(horarioColeta.num_hora_inicial);
      const menorHorarioDia = menorHorarioDias.get(horarioColeta.num_dia_semana);

      if (!menorHorarioDia || horarioTime < menorHorarioDia.horarioTime) {
        const [h, m] = horarioColeta.num_hora_inicial.split(':').map(Number);
        const horario = `${`00${h}`.slice(-2)}:${`00${m}`.slice(-2)}`;
        const isDiurno = h > 5 && h < 17;

        menorHorarioDias.set(horarioColeta.num_dia_semana, {
          hora: h,
          horario: `${`00${h}`.slice(-2)}:${`00${m}`.slice(-2)}`,
          horarioTime: horarioTime,
          turno: `${isDiurno ? 'Diurno' : 'Noturno'} (a partir de ${horario})`,
        });
      }
    });

    menorHorarioDias.forEach((horarioDia, num_dia_semana) => {
      const dia = dias[num_dia_semana];

      if (!dia) return;

      const infoHorario = infoHorarios.get(horarioDia.horario);

      const dias_com_este_horario = infoHorario?.dias_com_este_horario || new Set();

      if (!infoHorario) {
        const isDiurno = horarioDia.hora > 5 && horarioDia.hora < 17;
        const turno = `${isDiurno ? 'Diurno' : 'Noturno'} (a partir de ${horarioDia.horario})`;

        infoHorarios.set(horarioDia.horario, { horario: horarioDia.horario, dias_com_este_horario, turno });
      }

      dias_com_este_horario.add(dia);
    });

    return [...infoHorarios.values()].map((v) => ({ ...v, dias: [...v.dias_com_este_horario].join(', ') }));
  }, [areaColetaBuscada]);

  const conteudoCardConsulta = (
    <>
      {infoColeta.map((infoColeta) => (
        <React.Fragment key={infoColeta.horario}>
          <TitleFloat>Detalhes da consulta</TitleFloat>
          <TextFloat marginTop="6px">
            <b>Número do setor:</b> {areaColetaBuscada?.nom_area_coleta}
          </TextFloat>
          <TextFloat>
            <b>Dias de coleta:</b> {infoColeta?.dias || 'Sem informação'}
          </TextFloat>
          <TextFloat>
            <b>Turno de coleta:</b> {infoColeta?.turno || 'Sem informação'}
          </TextFloat>
        </React.Fragment>
      ))}

      {!!areaColetaBuscada?.position?.endereco && (
        <TextFloat useGrayColor marginTop="20px">
          {areaColetaBuscada?.position?.endereco}
        </TextFloat>
      )}

      <TextFloat useGrayColor marginTop={areaColetaBuscada?.position?.endereco ? '2px' : '20px'}>{`Data: ${dayjs(
        dataConsulta,
      ).format('DD/MM/YYYY HH:mm')}`}</TextFloat>
    </>
  );

  React.useEffect(() => {
    if (coordsParque) setMapLatLng(coordsParque);
  }, [coordsParque]);

  React.useEffect(() => {
    if (areaColetaBuscada?.position?.latitude && areaColetaBuscada?.position?.longitude) {
      setMapLatLng([areaColetaBuscada.position.latitude, areaColetaBuscada.position.longitude]);
    }
  }, [areaColetaBuscada?.position]);

  return (
    <FrameData>
      <Form target="_self" id="form-busca-coleta" onSubmit={makeHandleSubmit(() => handleBuscarAreaColeta())}>
        <SearchContainer>
          <Input
            stretch={2}
            value={enderecoBuscado}
            name="endereco"
            label="Endereço"
            placeholder="Digite seu endereço com o número"
            type="text"
            handleFunction={(e) =>
              setDadosConsultaAreaColeta((prevState) => ({ ...prevState, enderecoBuscado: e.target.value }))
            }
          />

          <Button
            stretch={1}
            type="button"
            loading={loading_buscar_com_localizacao}
            onClick={() => handleBuscarAreaColeta(true)}
          >
            <MdMyLocation />
            Usar minha localização
          </Button>

          <Button stretch={1} type="submit" loading={loading}>
            Buscar <FaSearch />
          </Button>
        </SearchContainer>

        <AutoRow>
          {!erroConsultaAreaColeta && (
            <>
              <MapContainer>
                {mapLatLng && (
                  <Mapa
                    scrollWheelZoom
                    doubleClickZoom={false}
                    zoom={14}
                    coordsOffset={[0, 0.015]}
                    coords={mapLatLng}
                    refMapElement={mapElement}
                    maxZoom={30}
                  >
                    {!!areaColetaBuscada && (
                      <>
                        <GeoJSON
                          key={areaColetaBuscada?.seq_area_coleta}
                          data={areaColetaBuscada?.area_json}
                          fillColor="#73C498"
                          color="#73C498"
                        />

                        <Marker position={mapLatLng} icon={MarkerIcon} />

                        <Popup
                          className="popup-info-area-coleta"
                          autoClose={false}
                          closeOnClick={false}
                          closeButton={false}
                          position={mapLatLng}
                          offset={[200, 110]}
                        >
                          <MapFloat>{conteudoCardConsulta}</MapFloat>
                        </Popup>
                      </>
                    )}
                  </Mapa>
                )}
              </MapContainer>

              <MapFloat showOnlySmallScreen>{conteudoCardConsulta}</MapFloat>

              {/* <Button
                onClick={() => {
                  setDadosConsultaAreaColeta({ enderecoBuscado: '' });
                  history.push('/');
                }}
              >
                Voltar
              </Button> */}
            </>
          )}
        </AutoRow>

        {!!erroConsultaAreaColeta && (
          <>
            <LineSpacer />
            <EmptyData redColor noPadding icon={() => <FaRegCompass />}>
              <b>{erroConsultaAreaColeta}</b>
            </EmptyData>
          </>
        )}
      </Form>
    </FrameData>
  );
};

export default IframeColeta;
